/**
 * 缺图/缺字时点 Create：不弹报错提示，把那一栏滚进视野、聚焦，再闪两下红框（10/21 老公定）。
 * 动画在 globals.css 的 .missing-flash。上传框给根元素加 data-missing-field="image"。
 */
export function flashMissingField(element: Element | null | undefined) {
	if (!(element instanceof HTMLElement)) {
		return;
	}
	element.scrollIntoView({ block: "nearest", behavior: "smooth" });
	element.focus({ preventScroll: true });
	// 连点时先摘掉再加回，动画才会重播
	element.classList.remove("missing-flash");
	void element.offsetWidth;
	element.classList.add("missing-flash");
	element.addEventListener(
		"animationend",
		() => element.classList.remove("missing-flash"),
		{ once: true },
	);
}
